<div class="container-wrapper">
  <div class="container">
    <input
      type="file"
      multiple
      (change)="onFileSelected($event)"
      title=""
      #fileUpload />
    <div class="headline-document-upload-browse">
      <h3>{{ 'crud.fileUpload.dragAndDrop.title' | translate }}</h3>
      <h3>{{ 'crud.fileUpload.dragAndDrop.titleOr' | translate }}</h3>
    </div>

    <div class="document-upload-browse">
      <su-button
        skin="primary"
        [label]="'crud.fileUpload.dragAndDrop.browse' | translate"></su-button>
    </div>
  </div>
  <div class="files-list" data-debug="detail-file-upload_uploaded-files">
    <div
      *ngFor="let typedFileForm of typedFiles.controls; let i = index"
      class="single-file-container">
      <div class="single-file" [formGroup]="castToFormGroup(typedFileForm)">
        <div class="row-name">
          <mat-icon>attach_file</mat-icon>
          <div class="info">
            <h3 class="name">
              {{ typedFileForm.value.file.name }}
            </h3>
            <p class="size">
              {{ formatBytes(typedFileForm.value.file.size) }}
            </p>
            <mat-error
              *ngIf="checkForFileSizeError(typedFileForm) as errorMessage">
              <span [innerHtml]="errorMessage"></span>
            </mat-error>
          </div>
        </div>

        <div class="row-button-container">
          <su-button
            [skin]="'accent'"
            [icon]="'xmark'"
            (onClick)="detachFile(i)"
            [disabled]="busy"></su-button>
        </div>
      </div>
      <div
        *ngIf="
          getContentTypeList(
            typedFileForm.get('documentTypeId').value
          ) as contentTypes
        "
        class="content-types-hint">
        {{ 'documents.allowed__contentTypes' | translate: { contentTypes } }}
      </div>
    </div>
  </div>

  <div class="button-upload">
    <su-button
      skin="primary"
      icon="upload"
      [label]="'crud.file.upload' | translate"
      (onClick)="onUploadAndClose()"
      [disabled]="busy || !typedFiles.value.length"></su-button>
  </div>
</div>
<mat-error *ngIf="!form.valid && form.touched">
  <div class="error-message">
    <span
      [innerHtml]="
        'crud.fileUpload.error.missingRequiredFields' | translate
      "></span>
  </div>
</mat-error>

<app-spinner-overlay [show]="busy"></app-spinner-overlay>
